var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/home' }}},[_vm._v("首页")]),_c('el-breadcrumb-item',[_vm._v("C端数据管理")]),_c('el-breadcrumb-item',[_vm._v("教师信息管理")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }